import { useEffect, useState } from "react";
import { Button, Table } from 'react-bootstrap';
import { WeekSelector } from "../weeks/WeekSelector";
import { createEntry, retrieveGames, retrieveMyEntries } from '../../api/api';
import { EntrySelector } from "./EntrySelector";
import { toast } from "react-toastify";
import { ApprovalRequests } from "./ApprovalRequests";
import SeasonSignupModal from "./SeasonSignupModal";
import { SubmittedEntry } from "./SubmittedEntry";
import { UnsubmittedEntry } from "./UnsubmittedEntry";

function Entries(props) {
    const [selectedWeek, setSelectedWeek] = useState(null);
    const [entriesForWeek, setEntriesForWeek] = useState([]);
    const [selectedEntry, setSelectedEntry] = useState(null);
    const [games, setGames] = useState([]);
    const [showSeasonSignupModal, setShowSeasonSignupModel] = useState(false);

    useEffect(() => {
        setShowSeasonSignupModel(props.user && props.user.balance === 0 && props.user.entry_approval_requests.length === 0);
    }, [props.user]);

    useEffect(() => {
        if (selectedWeek) {
            retrieveMyEntries(selectedWeek.number).then((entries) => {
                setEntriesForWeek(entries);
            });
        }
    }, [selectedWeek]);

    useEffect(() => {
        if (!selectedWeek) {
            return;
        }

        retrieveGames(selectedWeek.number).then((games) => { setGames(games); });
    }, [selectedWeek]);

    const handleNewEntry = () => {
        createEntry(selectedWeek.number).then(() => {
            retrieveMyEntries(selectedWeek.number).then((entries) => {
                setEntriesForWeek(entries);
                toast.success("New entry created.");
            });
        });
    }

    const renderSubmittedEntries = () => {
        if (!entriesForWeek) {
            return <></>;
        }

        let submittedEntries = entriesForWeek.filter((e) => { return e.status !== 'PENDING'; })
        if (submittedEntries.length === 0) {
            return <></>;
        }

        return (
            <>
                <div className="row">
                    <div className="column">
                        <h2 className="py-4">Submitted</h2>
                        <Table striped borderless variant="dark" className="w-auto transparent">
                            <tbody>
                                {submittedEntries.map((e) => {
                                    return <SubmittedEntry key={e.id} entry={e} games={games} />;
                                })}
                            </tbody>
                        </Table>
                    </div>
                </div>
            </>
        );
    }

    const getPendingEntries = () => {
        return entriesForWeek.filter((e) => { return e.status === 'PENDING'; });
    }

    const renderPendingEntries = () => {
        if (!entriesForWeek) {
            return <></>;
        }

        let pendingEntries = getPendingEntries();
        if (pendingEntries.length === 0) {
            return <></>;
        }

        return (
            <>
                <div className="row">
                    <div className="column">
                        <h2 className="py-4">Pending</h2>
                        <table>
                            <tbody>
                                <tr>
                                    <td><EntrySelector id="entry-selector" entries={getPendingEntries()} entry={selectedEntry} setEntry={setSelectedEntry} /></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <UnsubmittedEntry entry={selectedEntry} setEntry={setSelectedEntry} setEntries={setEntriesForWeek} week={selectedWeek} games={games} setUser={props.setUser} setWeeks={props.setWeeks} />
            </>
        );
    }

    return (
        <>
            <div className="container">
                <ApprovalRequests user={props.user} setUser={props.setUser} />
                <div className="row">
                    <div className="column">
                        <h1 className="py-4">My Entries <Button className="ms-3" onClick={handleNewEntry}>New Entry</Button></h1>
                        <table>
                            <tbody>
                                <tr>
                                    <td><WeekSelector id="entry-week-selector" weeks={props.weeks} week={selectedWeek} setWeek={setSelectedWeek} noFutureWeeks={true} /></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                {renderSubmittedEntries()}
                {renderPendingEntries()}
                <SeasonSignupModal show={showSeasonSignupModal} setShow={setShowSeasonSignupModel} setUser={props.setUser} />
            </div>
        </>
    );
}

export default Entries;